import React from 'react'
import { Box } from './Base'

const Message = ({ variant, mb = 30, ...props }) => {
  const colors = {
    error: 'negative',
    success: 'tertiary',
    info: 'secondary'
  }

  const bgs = {
    error: 'bg_negative',
    success: 'bg_tertiary',
    info: 'bg_secondary'
  }

  const boxProps = {
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: colors[variant],
    color: colors[variant],
    borderRadius: 5,
    textAlign: 'center',
    fontSize: '1.6rem',
    lineHeight: '2.4rem',
    bg: bgs[variant],
    p: 20,
    mb,
    ...props
  }

  return <Box {...boxProps} />
}

export default Message
